export default [{
    id: "05601",
    name: "UZ Leuven",
}, ];